import { type MessageItem } from "@koala/sdk";
import { MessageList } from "./messageList";
import {
  StyledEmptyMessagesContainer,
  StyledInboxContainer,
  StyledMessagesContainer,
} from "./styles";
import StringAccessor from "@/components/cmsConfig/stringAccessor";

interface Props {
  messages: MessageItem[] | null;
}

export function Inbox({ messages }: Props) {
  return (
    <StyledInboxContainer>
      <StyledMessagesContainer>
        {/* Messages exist */}
        {/** @TODO ensure that `messages` isn't null. */}
        {/* @ts-expect-error */}
        {messages?.length > 0 ? (
          <MessageList />
        ) : (
          <StyledEmptyMessagesContainer>
            {messages?.length === 0 ? (
              // No messages
              <StringAccessor
                accessor="inbox.empty_state"
                html={true}
                tag="span"
              />
            ) : (
              // Loading messages
              <p>Loading messages...</p>
            )}
          </StyledEmptyMessagesContainer>
        )}
      </StyledMessagesContainer>
    </StyledInboxContainer>
  );
}
